import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { sortNews } from "./news-utils"

export default function NewsPost () {
    const { id } = useParams()
    const [postData, setPostData] = useState(null)

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch('/news.json', { cache: "no-store"})
                if (!res.ok) throw new Error(`HTTP ${res.status}`)

                const data = await res.json()
                const sorted = sortNews(data)
                setPostData(sorted.find(p => String(p.id) === String(id)) || null)
            } catch (e) {
                console.error(e)
            }
        })()
    },[])

    return (
        <>
            <div class='w-full bg-white flex flex-col items-center'>
            <div class='max-w-[1400px] w-full flex flex-col items-center py-[20px] md:py-[50px] px-[20px]'>

                {
                    postData !== null ? (
                        <>
                            <h1 class='small-caps text-bja-secondary font-semibold text-[32px]'>{postData.title}</h1>
                            <div class='flex items-center w-full my-[15px]'>
                                <div class='flex-grow border-t border-bja-primary'></div>
                                <span class='mx-2 text-bja-primary small-caps text-sm md:text-base'>{postData.date} | {postData.tags[0]}</span>
                                <div class='flex-grow border-t border-bja-primary'></div>
                            </div>
                            <p class='news-content w-full pb-4' >{postData.text}
                            </p>

                            {postData.mediaType === 'share' && <a className="w-full text-bja-secondary hover:text-bja-primary" href={postData.shareLink} >{postData.shareLink}</a>}
                            {postData.mediaType === 'video_inline' && <div dangerouslySetInnerHTML={{ __html: postData.videoIframeHtml }} />}
                            {postData.image && <img src={postData.image} />}

                        </>
                    ) : (
                        <p class='text-black'>Hír betöltése</p>
                    )


                }
            </div>
        </div>

        </>
    )
}